import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
// TEMPORARY FONT SWAP — remove this import (and src/styles/temporary-font-override.css) to restore Lora
import "./styles/temporary-font-override.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ProductProvider } from "./context/ProductContext";
import { CartProvider } from "./context/CartContext";
import { ExtraProvider } from "./context/ExtraContext";
import { SearchProvider } from "./context/SearchContext";
import { CollectionsProvider } from "./context/CollectionsContext";
import { MainCategoryProvider } from "./context/MainCategoryContext";
import { ProductAttributeProvider } from "./context/ProductAttributeContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(

  <BrowserRouter>
      <AuthProvider>
        <SearchProvider>
          <ExtraProvider>
            <MainCategoryProvider>
              <ProductAttributeProvider>
                <ProductProvider>
                  <CartProvider>
                    <CollectionsProvider>
                      <App />
                    </CollectionsProvider>
                  </CartProvider>
                </ProductProvider>
              </ProductAttributeProvider>
            </MainCategoryProvider>
          </ExtraProvider>
        </SearchProvider>
      </AuthProvider>
  </BrowserRouter>

);

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Register service worker for caching
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('Service Worker registered successfully:', registration.scope);
      })
      .catch((error) => {
        console.log('Service Worker registration failed:', error);
      });
  });
}